import React from 'react';
//Components
import PopUp from './popup';
//Material-UI
import { TextField, Button } from '@material-ui/core';
//Icons
import { CirclePlus } from 'tabler-icons-react';
//Context
import { useProductos } from './ProductosContext';

export default function NuevoProducto() {
    const { postNewProd, handleinputChange } = useProductos();
    const createOrd = (e) => {
        e.preventDefault();
        postNewProd(e);
    };
    return (
        <PopUp
            name="nuevo"
            buttonClass=""
            colorButton="default"
            isContained="text"
            textButton={
                <span className="productos-btn-content">
                    <CirclePlus size={16} strokeWidth={1.75} /> Nuevo Producto
                </span>
            }
            popupSeconButton="Cancelar"
            title="Nuevo Producto"
            titleDesc="Crear un nuevo producto definiendo su nombre y código SKU y añádelo al catálogo"
            popupBody={
                <div className="popupbody">
                    <div className="popuptextfield">
                        <TextField
                            id="uxTxtOrdenProd"
                            name="nombre"
                            label="NOMBRE DEL PRODUCTO"
                            fullWidth
                            onChange={handleinputChange}
                        />
                    </div>
                    <div className="popuptextfield">
                        <TextField
                            id="uxTxtProducto"
                            name="sku"
                            label="CLAVE DEL PRODUCTO SKU"
                            fullWidth
                            onChange={handleinputChange}
                        />
                    </div>
                    <div className="popuptextfield">
                        <TextField
                            id="uxTxtPzasPaq"
                            name="piezasPorPaquete"
                            label="PIEZAS/PAQUETE"
                            fullWidth
                            onChange={handleinputChange}
                        />
                    </div>
                    <div className="popuptextfield">
                        <TextField
                            id="uxTxtPzasTar"
                            name="paquetesPorTarima"
                            label="PAQUETES/TARIMA"
                            fullWidth
                            onChange={handleinputChange}
                        />
                    </div>
                </div>
            }
            popupPrimAction={
                <Button
                    color="primary"
                    variant="contained"
                    className="popup-button-p"
                    onClick={(e) => createOrd(e)}
                >
                    Crear nuevo Producto
                </Button>
            }
        />
    );
}
